module.exports = __webpack_public_path__ + "img/home_slider_05.da4db531.jpg";